export const splitUrl = (link?: string): string | undefined => {
    return link?.includes('//') ? link?.split('//')[1] : link;
};

export const isDevelopment = (): boolean => process.env.NODE_ENV === 'development';

const submitKeys = ['Space', 'Enter', 'NumpadEnter'];
export const isSubmitKey = (event: React.KeyboardEvent<HTMLSpanElement>): boolean => submitKeys.includes(event.code);
